import React from "react"
import classnames from "classnames"
import styles from "./OfferTile.less"
import componentParser from "AtomicUtils/componentParser"
import gtmHandler from "AtomicUtils/gtmHandler"
import { H5, H6, Interactive, P, Space } from "AtomicComponents"
import { Image, AccordionText } from "AtomicContainers"

class OfferTile extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      open: 0,
    }
  }

  render() {
    const { imageSrc, nameplate, bodyGrade, heading, subHeading, offerPoints, components, disclaimer, isFeatured = false } = this.props

    return (
      <div
        className={classnames({
          [styles.OfferTile]: true,
          [styles.OfferTileFeatured]: isFeatured,
        })}>
          <div
            className={classnames({
              [styles.OfferTileVehicle]: true
            })}>
              <H6 withDetails>{nameplate}</H6>
              <Interactive>{bodyGrade}</Interactive>
              <Space />
              <div
                className={classnames({
                  [styles.OfferTileImage]: true
                })}>
                <Image src={imageSrc} height={200} type="spinner" />
              </div>
          </div>
          <div
            className={classnames({
              [styles.OfferTileContent]: true
            })}>
            <H5 withDetails>{heading}</H5>
            <Interactive>{subHeading}</Interactive>
            <Space />
            {
              offerPoints && offerPoints.map((point, index) => {
                return index <= 1 && <P key={index} withoutMargin>{point}</P>
              })
            }
            {
              offerPoints && offerPoints.length > 2 &&
              <AccordionText
                styleName="info"
                onClick={() => {
                  gtmHandler({
                    pageCategory: "Offers",
                    pageAction: `More Info - "${nameplate} / ${bodyGrade} / ${heading}" - "MORE INFO"`
                  })
                }}>
                {offerPoints.map((point, index) => {
                  return index > 1 && <P key={index} withoutMargin>{point}</P>
                })}
              </AccordionText>
            }
            <Space />
            <Space />
            <div
              className={classnames({
                [styles.OfferTileButtons]: true
              })}>
              {componentParser(components)}
            </div>
            {
              disclaimer &&
              <AccordionText
                title={"Disclaimer"}
                styleName="disclaimer"
                onClick={() => {
                  gtmHandler({
                    pageCategory: "Offers",
                    pageAction: `Disclaimers - "${nameplate} / ${bodyGrade} / ${heading}" - "DISCLAIMERS"`
                  })
                }}>
                <label>{disclaimer}</label>
              </AccordionText>
            }
          </div>
      </div>
    )
  }
}


export default OfferTile



// WEBPACK FOOTER //
// ./src/AtomicContainers/OfferTile/OfferTile.jsx